import { Registration } from '@stax-core/types-omni';
import { USD } from '../../../util/currency.util';

export const fdDirectMapper = (r: Registration) => ({
  mastercardvisa_volume:
    USD.parse(r.annual_volume || '0')
      ?.multiply(0.9)
      .format() || '',
  discovernetwork_paypal_volume:
    USD.parse(r.annual_volume || '0')
      ?.multiply(0.05)
      .format() || '',
  amexoptblue_volume:
    USD.parse(r.annual_volume || '0')
      ?.multiply(0.05)
      .format() || '',
});
